<template>
  <div>
    <div ref="component" class="simple cx_style">
      <div class="content-item">
        <div class="content flex">
          <div class="upload" :class="'img-size-' + size">
            <span v-show="!noImg && showDel" class="icon-portal-delete del-bg-icon" @click="delBgImage"></span>
            <img v-if="iconTypeVal === 'img'" :src="imgVal || defaultImg" name="uploadFile" />
            <div class="upload-icon-box" v-if="iconTypeVal === 'icon'" v-html="svg">
              <!-- <embed v-if="iconTypeVal === 'img'" :src="svg" width="24" type="image/svg+xml" /> -->
            </div>
          </div>
          <div class="text ml16" :class="'text-width-' + size">
            <div style="height: 38px">
              <div class="description mb2" v-if="!resourceShow">格式：PNG/JPG/GIF</div>
              <div class="description mb2 overflowHid1" v-else>
                名称：<span v-if="resInfoVal.name">{{ resInfoVal.name }}</span
                ><span v-else>名称</span>
              </div>
              <div class="description mb2">
                大小：
                <span v-if="iconType === 'img'">
                  <span v-if="resInfoVal.content">{{ resInfoVal.content.length }}</span
                  ><span v-else>1M以下</span>
                </span>
                <span v-if="iconType === 'icon'">4kb</span>
              </div>
            </div>
            <div class="mt7 upload-btns">
              <span class="common_btn_28_20 mr10" v-if="uploadShow">
                <input
                  type="file"
                  accept="image/gif,image/jpeg,image/jpg,image/png"
                  @change="uploadImg($event)"
                />上传</span
              >
              <span class="common_btn_28_20" @click="openImgLib" v-if="resourceShow && uploadShow">资源库</span>
              <span class="common_btn_28_20" @click="openImgLib" v-if="resourceShow && !uploadShow">图标库</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--图片库-->
    <resourceLib
      :visible.sync="imgResDialogVisible"
      :iconType.sync="iconTypeVal"
      :imgSrc.sync="imgVal"
      :iconColor.sync="iconColorVal"
      :resInfo.sync="resInfoVal"
    />
  </div>
</template>

<script>
import "../common.css"
import defaultImgSrc from "../../assets/images/default_image.png"
import publicData from "../mixins/publicData.js"
import primaryImg from "assets/images/primaryImage.png"
import emptyImg from "assets/images/empty_img_bg.png"
import { uploadResources } from "../../utils"
import instance from "../../interceptor"
import resourceLib from "./resourceLib"
export default {
  mixins: [publicData],
  name: "imgIconUpload",
  components: { resourceLib },
  props: {
    imgSrc: {
      type: [String, Number],
      required: true,
      default: ""
    },
    iconType: {
      type: String,
      required: true,
      default: "img"
    },
    iconColor: {
      type: [String, Object],
      required: true,
      default: ""
    },
    defaultImg: {
      type: String,
      required: false
    },
    themeKey: {
      type: String,
      required: false
    },
    //10 1.0素材     11大屏背景   12大屏图片  13布局背景    14其他
    imgType: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: "small",
      required: false
    },
    uploadShow: {
      type: Boolean,
      default: true,
      required: false
    },
    resourceShow: {
      type: Boolean,
      default: true,
      required: false
    },
    showDel: {
      type: Boolean,
      default: true,
      required: false
    },
    resInfo: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      imgResDialogVisible: false,
      contextPath: "",
      classify: [],
      // wfwfid: undefined,
      imgList: [],
      noImg: true,
      activeIconType: 0,
      iconTypes: [
        {
          typeId: 0,
          label: "面性图标"
        },
        {
          typeId: 1,
          label: "线性图标"
        }
      ],
      svg: "",
      icons: [
        {
          typeId: 0,
          svgLists: [
            {
              type: "医疗",
              list: [
                {
                  name: "3D眼镜_three-d-glasses",
                  keyWord: "医疗"
                },
                {
                  name: "3D眼镜_three-d-glasses",
                  keyWord: "医疗"
                }
              ]
            },
            {
              type: "医疗2222",
              list: [
                {
                  name: "3D眼镜_three-d-glasses",
                  keyWord: "医疗"
                },
                {
                  name: "3D眼镜_three-d-glasses",
                  keyWord: "医疗"
                }
              ]
            }
          ]
        },
        {
          typeId: 1,
          list: [
            {
              name: "icon-portal-delete"
            }
          ]
        }
      ],
      searchContent: "",
      leftMenuList: [],
      rightCatetoryList: [],
      leftMenuActiveIndex: 0,
      rightCatetoryActiveId: -1,
      rightIconList: [],
      totalNum: 0
    }
  },
  computed: {
    defaultImage() {
      return this.defaultImg || defaultImgSrc
    },
    imgVal: {
      get() {
        this.noImg = this.imgSrc.length === 0 ? true : false
        return this.imgSrc.length ? this.imgSrc : this.request_prefix === "bigScreen" ? emptyImg : primaryImg
      },
      set(val) {
        this.$emit("update:imgSrc", val)
        this.getSvgContent(val)
      }
    },
    iconTypeVal: {
      get() {
        return this.iconType
      },
      set(val) {
        this.$emit("update:iconType", val)
      }
    },
    showIcons() {
      return this.icons.find(item => {
        return item.typeId === this.activeIconType
      }).list
    },
    wfwfid() {
      return this.$store.state.states.getDataPageIds.wfwfid
    },
    iconColorVal: {
      get() {
        return this.iconColor || ""
      },
      set(val) {
        this.$emit("update:iconColor", val)
      }
    },
    resInfoVal: {
      get() {
        return this.resInfo || {}
      },
      set(val) {
        this.$emit("update:resInfo", val)
      }
    }
  },
  watch: {
    imgSrc(n, o) {
      if (n) {
        this.getSvgContent(n)
      }
    }
  },
  mounted() {
    this.contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
    this.getSvgContent(this.imgSrc)
  },
  methods: {
    uploadImg(e) {
      let file = e.target.files[0]
      let _this = this
      uploadResources(file, 5, this, function (imgSrc) {
        _this.iconTypeVal = "img"
        _this.imgVal = imgSrc
      })
    },
    delBgImage() {
      this.imgVal = ""
    },
    openImgLib() {
      this.imgResDialogVisible = true
      // this.getIconAllTypes()
    },
    selectImage(image) {
      this.imgVal = image.name
      this.iconTypeVal = "icon"
      this.imgResDialogVisible = false
    },
    changeIconType(id) {
      this.activeIconType = id
    },
    searchImgHandle() {
      this.getRightImgList(this.leftMenuActiveIndex, this.rightCatetoryActiveId, 1, this.searchContent.trim())
    },
    leftMenuActiveHandle(item) {
      this.leftMenuCurrentIndex = item.id
    },
    chooseRightType(item) {
      if (item !== null) {
        this.rightCatetoryActiveId = item.id
      } else {
        this.rightCatetoryActiveId = null
      }
      this.getRightImgList(this.leftMenuActiveIndex, this.rightCatetoryActiveId, 1, null)
    },
    // 获取所有图标分类
    getIconAllTypes() {
      this.instance
        .get(this.contextPath + "v2/resource/all-classify?type=2", {
          wfwfid: this.wfwfid
        })
        .then(res => {
          if (res.data.code === 1) {
            this.leftMenuList = res.data.data
            this.rightCatetoryList = res.data.data[0].subClassify
            this.leftMenuActiveIndex = res.data.data[0].id
            this.getRightImgList(this.leftMenuActiveIndex, "", 1, null)
          }
        })
    },
    getRightImgList(firstClassifyId, secondClassifyId, pageNum, tag) {
      this.instance
        .get(this.contextPath + "v2/resource/query-by-classify", {
          params: {
            wfwfid: this.wfwfid,
            firstClassifyId: firstClassifyId,
            secondClassifyId: secondClassifyId == -1 ? null : secondClassifyId,
            pageNum: pageNum,
            pageSize: 80,
            tag: tag
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            this.rightIconList = res.data.data.list
            this.totalNum = res.data.data.total
          }
        })
    },

    pageNumChangeHandle(page) {
      this.getRightImgList(this.leftMenuActiveIndex, this.rightCatetoryActiveId, page, null)
    },
    chooseCurrentIconHandle(item) {
      this.iconTypeVal = "icon"
      this.svg = item.content
      this.imgVal = item.encrypt
    },
    getSvgContent(encrypt) {
      if (!!encrypt) {
        let svgContent = this.$store.state.states.iconSvg
        if (svgContent && svgContent.encrypt?.trim()) {
          this.svg = svgContent[encrypt]
          return
        }
        if (!svgContent || !svgContent.hasOwnProperty(encrypt)) {
          this.$store.commit("states/updateSvg", {
            svgId: encrypt,
            value: " "
          })
        }
        this.$API
          .querySvg({
            publicId: encrypt
          })
          .then(res => {
            if (res?.status !== 200) return
            this.svg = res.data
            this.$store.commit("states/updateSvg", {
              svgId: encrypt,
              value: res.data
            })
          })
      } else {
        this.svg = ""
      }
    }
  }
}
</script>

<style scoped>
/*图片上传出的样式*/
.upload {
  position: relative;
  background: var(--rootBgColor);
  border: 1px solid var(--sliderBackGround);
  border-radius: 4px;
  overflow: hidden;
}
.upload .del-bg-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 10;
  cursor: pointer;
}
.content .upload {
  width: 90px;
  height: 90px;
  text-align: center;
  font-size: 0;
}
.upload .img-icon {
  display: inline-block;
  font-size: 21px;
  line-height: 90px;
}
.content .img-size-small {
  width: 72px;
  height: 72px;
  background: url("../../assets/images/primaryImage.png");
}
.content .img-size-medium {
  width: 90px;
  height: 90px;
}
.content .upload img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.content .upload .del-bg-icon {
  position: absolute;
  display: none;
  bottom: 4px;
  top: auto;
  right: 4px;
  z-index: 10;
  cursor: pointer;
  font-size: 14px;
  width: 18px;
  line-height: 18px;
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 3px;
  color: #ffffff;
}
.content .upload .del-bg-icon:hover {
  background: rgba(0, 0, 0, 0.8);
}
.content .upload:hover .del-bg-icon {
  display: block;
}
.upload-btns input[type="file"] {
  width: 38px;
}
.upload-btns span {
  cursor: pointer;
}
.el-select:hover .el-input__inner {
  border: none;
}
.el-color-dropdown .el-input__inner {
  background: #f7f7f7;
}
.content .description {
  font-size: 12px;
  line-height: 17px;
}

.icon-boxs > li {
  display: inline-block;
  vertical-align: top;
  margin: 0 8px 8px 0;
}
.icon-boxs > li:nth-child(8n) {
  margin-right: 0;
}
.icon-box span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  text-align: center;
  box-sizing: border-box;
  /* font-size: 21px; */
  cursor: pointer;
  border: 1px solid var(--sliderBackGround);
  border-radius: 8px;
}
.icon-box span:hover {
  /* border: 2px solid var(--themeColor); */
  box-shadow: inset 0px 0px 0px 2px var(--themeColor);
}
::v-deep .imgResDialog {
  /* width: 904px;
  height: 745px; */
  width: 1016px;
  height: 600px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--borderColorFive);
}
::v-deep .imgResDialog .el-dialog__header {
  padding: 15px 20px;
  border-bottom: 1px solid var(--borderColorFive);
}
::v-deep .imgResDialog .el-dialog__body {
  display: flex;
  overflow: hidden;
  padding: 0px 0 0 16px;
  box-sizing: border-box;
  height: 545px;
}
::v-deep .el-scrollbar__wrap {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
}
::v-deep .scrollbar {
  margin-top: 8px;
  height: calc(100% - 42px);
}
::v-deep .el-dialog__headerbtn {
  top: 12px;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  /* color: rgba(255, 255, 255, 0.6); */
  color: var(--imgDialogIconColor);
  font-size: 20px;
}
.icon-types > li {
  display: inline-block;
  padding: 0 6px;
  width: 77px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #f5f5f5;
  border-radius: 2px;
  margin-right: 8px;
  cursor: pointer;
}
.icon-types > li.active {
  color: var(--themeColor);
  background-color: var(--themeColorSelectBg);
}
::v-deep .el-dialog__title {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: var(--elCollapseItemHeaderColor);
}

.imgResDialog .img-left-menu {
  position: relative;
  padding-right: 16px;
  padding-top: 16px;
  width: 150px;
  height: 100%;
  border-right: 1px solid rgba(0, 0, 0, 0.07);
  box-sizing: border-box;
}
.imgResDialog .img-left-menu .menu-item {
  cursor: pointer;
  padding: 10px 12px 10px 16px;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: var(--textColor);
}
.imgResDialog .img-left-menu .menu-item.active {
  background: rgba(61, 130, 242, 0.1);
  border-radius: 8px;
  color: #3d82f2;
}
.imgResDialog .img-right-list {
  flex: 1;
  padding: 16px 0 16px 16px;
  box-sizing: border-box;
}

.imgResDialog .img-right-list .choose-container {
}

.imgResDialog .img-right-list .choose-container .el-dropdown {
  margin-right: 16px;
  line-height: 28px;
}

.imgResDialog .search-box {
  margin-right: 16px;
  float: right;
  position: relative;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  width: 220px;
  height: 30px;
  background: var(--inputBackGround);
  border-radius: 4px;
  box-sizing: border-box;
}
.imgResDialog .search-box > input {
  width: 148px;
  height: 18px;
  background: transparent;
  color: var(--textColor);
}
.imgResDialog .search-box .clear-btn {
  /* display: none; */
  cursor: pointer;
  position: absolute;
  top: 7px;
  right: 31px;
  font-size: 16px;
  color: var(--imgDialogIconColor);
}
.imgResDialog .search-box .search-btn {
  cursor: pointer;
  position: absolute;
  top: 7px;
  right: 7px;
  font-size: 16px;
  /* color: rgba(0, 0, 0, 0.2); */
  color: var(--imgDialogIconColor);
}
.select-down-list {
  position: relative;
  display: inline-block;
  vertical-align: top;
}
.select-down-list .select-title {
  cursor: pointer;
  padding: 0 6px;
  display: inline-block;
  height: 28px;
  line-height: 28px;
}

.select-down-list .select-title i {
  transition: all ease-in-out 300ms;
}
.select-down-list .select-title:hover {
  background: #f3f3f3;
  border-radius: 4px;
}
.select-down-list:hover i {
  display: inline-block;
  transform: rotate(180deg);
}
.select-down-list:hover .select-lists {
  display: block;
}
.select-down-list .select-lists {
  display: none;
  position: absolute;
  left: 0;
  top: 28px;
  padding-top: 8px;
  height: 288px;
  z-index: 2;
}
.select-down-list .select-lists .el-scrollbar {
  border: 1px solid #e9e9e9;
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12);
}
.select-down-list .select-lists .subclassify-list {
  width: 120px;
  background: #ffffff;
  border-radius: 4px;
}
.select-down-list .select-lists .subclassify-list > li {
  cursor: pointer;
  padding: 0px 12px;
  height: 40px;
  background: #ffffff;
  line-height: 40px;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
}

.select-down-list .select-lists .subclassify-list > li:hover {
  color: var(--themeColor);
}
.iconpark-tips {
  margin-top: 16px;
  font-size: 12px;
  line-height: 17px;
  color: rgba(0, 0, 0, 0.4);
  text-align: center;
}
.iconpark-tips span {
  color: var(--themeColor);
}
.upload-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.upload-icon-box * {
  width: 100%;
  height: 100%;
}
.upload-icon-box embed body {
  margin: 0;
}
::v-deep .upload-icon-box svg {
  width: 24px;
  height: 24px;
}
/* 分页 */
.el-pagination {
  text-align: center;
}
::v-deep .el-pagination button,
.el-pagination span:not([class*="suffix"]),
::v-deep .el-pager li {
  height: 24px;
  line-height: 24px;
}
::v-deep .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  /* min-width: 24px; */
}
.text-width-small {
  width: calc((100% - 88px));
}
.text-width-medium {
  width: calc((100% - 106px));
}
@media screen and (min-width: 1580px) {
  /* ::v-deep  .imgResDialog {
    width: 1520px;
  } */
}

@media screen and (min-width: 1256px) and (max-width: 1579px) {
  /* ::v-deep .imgResDialog {
    width: 1196px;
  }
  ::v-deep .icon-boxs > li:nth-child(10n) {
    margin-right: 8px;
  }
  ::v-deep .icon-boxs > li:nth-child(14n) {
    margin-right: 0;
  } */
}

@media screen and (min-width: 932px) and (max-width: 1255px) {
  /* ::v-deep  .imgResDialog {
    width: 872px;
  }
  ::v-deep .icon-boxs > li:nth-child(9n) {
    margin-right: 0;
  }
  ::v-deep .icon-boxs > li:nth-child(10n) {
    margin-right: 8px;
  }
  ::v-deep .icon-boxs > li:nth-child(14n) {
    margin-right: 8px;
  } */
}
@media screen and (max-width: 931px) {
  /* ::v-deep  .imgResDialog {
    width: 548px;
  } */
}
</style>
